// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ac94bddc","532":"6b2430ef","584":"60a3bbb0","629":"5fd840e8","726":"5f251414","761":"b1f9a629","916":"f7262293"}[chunkId] + ".chunk.js";
};